import { useRef, useState, type ReactNode } from 'react'
import type { GrupoCatalogo, ProdutoCatalogo } from '@/api'
import { Button, Dialog, DialogContent, InputAdornment, Stack, TextField, Typography, } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import GradeProdutos from './grade-produtos'
import { CabecalhoModal } from '@/components/cabecalho-modal'

interface DialogBuscaProps {
  aberto: boolean
  grupos: GrupoCatalogo[]
  renderCard: (produto: ProdutoCatalogo, cor: string | null) => ReactNode
  larguraMinimaCard?: string
  aoFechar: () => void
}

export function DialogBusca({ aberto, grupos, renderCard, larguraMinimaCard, aoFechar }: DialogBuscaProps): JSX.Element {
  const [termo, setTermo] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  const fechar = (): void => {
    setTermo('')
    aoFechar()
  }

  return (
    <Dialog
      open={aberto}
      onClose={fechar}
      fullScreen
      slotProps={{
        transition: {
          onEntered: () => inputRef.current?.focus()
        }
      }}
    >
      <CabecalhoModal
        aoFechar={fechar}
        acao={
          termo ? (
            <Button color="inherit" onClick={() => setTermo('')}>
              Limpar
            </Button>
          ) : undefined
        }
      >
        <TextField
          value={termo}
          onChange={(e) => setTermo(e.target.value)}
          placeholder="Buscar no cardápio"
          fullWidth
          autoFocus
          inputRef={inputRef}
          variant="standard"
          slotProps={{
            input: {
              disableUnderline: true,
              sx: { fontSize: '1.5rem' },
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" fontSize="large" />
                </InputAdornment>
              ),
            }
          }}
        />
      </CabecalhoModal>

      <DialogContent sx={{ p: 0, pl: 2, display: 'flex' }}>
        {!termo.trim() ? (
          <Stack sx={{ flexGrow: 1, alignItems: 'center', justifyContent: 'center', gap: 1.5, p: 2 }}>
            <SearchIcon sx={{ fontSize: 72, opacity: 0.4 }} />

            <Typography variant="h5" color="text.secondary" textAlign="center">
              Digite para buscar produtos pelo nome ou descrição.
            </Typography>
          </Stack>
        ) : (
          <GradeProdutos
            grupos={grupos}
            selectedCategoryId={null}
            termoBusca={termo}
            renderCard={renderCard}
            larguraMinimaCard={larguraMinimaCard}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
